import { Link, useLocation } from "react-router-dom";
import { Camera, FolderHeart, HardHat, Users, User } from "lucide-react";
import { joinClassNames } from "@/lib/classNames";
import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";

const bottomNavItems = [
  { path: "/identify", label: "Identify", icon: Camera },
  { path: "/my-finds", label: "My Finds", icon: FolderHeart },
  { path: "/careers", label: "Careers", icon: HardHat },
  { path: "/community", label: "Community", icon: Users },
  { path: "/account", label: "Account", icon: User },
];

export function MobileBottomNav() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const location = useLocation();

  if (!user || !isMobile) return null;

  return (
    <nav
      aria-label="Primary mobile navigation"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border/50 bg-background/80 backdrop-blur-xl safe-bottom shadow-[0_-4px_20px_-4px_hsl(var(--foreground)/0.08)]"
    >
      <div className="grid grid-cols-5 gap-0.5 px-1 py-1.5">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={joinClassNames(
                "flex flex-col items-center gap-0.5 py-2 rounded-xl transition-all duration-200",
                "active:scale-95",
                isActive
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <div className={joinClassNames(
                "flex items-center justify-center w-8 h-8 rounded-xl transition-all duration-200",
                isActive && "bg-primary/12 shadow-sm"
              )}>
                <item.icon className={joinClassNames("h-5 w-5 transition-all duration-200", isActive && "scale-105")} />
              </div>
              <span className={joinClassNames(
                "text-[10px] leading-tight transition-all duration-200",
                isActive ? "font-semibold" : "font-medium"
              )}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
